import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import { pipelineOptionFromEntity } from 'components/forms/autocomplete/Pipeline';
import { isPluginActive } from 'helpers/whiteLabel';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormTags from 'components/forms/FormTags';
import FormSwitchery from 'components/forms/FormSwitchery';

class LeadPerMailRuleData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      projectConfig,
    } = this.props;

    const dataEmailCoPluginActive = isPluginActive('DATA_EMAIL_CO', projectConfig.data);
    const salesActivityDashboardPluginActive = isPluginActive('SALES_ACTIVITY_DASHBOARD', projectConfig.data);

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p>{messages.formGroup.basic_information}</p>

                    {salesActivityDashboardPluginActive && (
                      <ButtonToolbar class="m-b-15">
                        <ToggleButtonGroup
                          class="col-xs-12 no-padding"
                          type="radio"
                          name="type"
                          value={entity.getType()}
                          onChange={value => this.updateEntity('type', value)}
                          defaultValue="lead"
                        >
                          <ToggleButton value="lead" class="col-xs-6">
                            {messages.lead}
                          </ToggleButton>
                          <ToggleButton value="sadActivity" class="col-xs-6">
                            {messages.sad_activity}
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </ButtonToolbar>
                    )}

                    <div class="form-group-attached">
                      <FormInput
                        name="name"
                        label={messages.name}
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />

                      {/* if the type is a lead, select the pipeline too */}
                      {entity.getType() === 'lead' ? (
                        <FormAutocomplete
                          label={messages.pipeline}
                          name="pipeline"
                          value={pipelineOptionFromEntity(entity.getPipeline())}
                          meta={entity.getPipelineMetaInformation()}
                          validation={entity.getPipelineValidationResult()}
                          onChange={this.updateEntity}
                          returnValueObject
                          autocompleteType="pipeline"
                          disabled={disabled}
                        />
                      ) : null}

                      {/* if the type is a SAD activity, optional select the activity source (defaults to "all") */}
                      {entity.getType() === 'sadActivity' ? (
                        <FormAutocomplete
                          label={messages.source}
                          name="source"
                          value={entity.getSource()}
                          meta={entity.getSourceMetaInformation()}
                          validation={entity.getSourceValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                          options={[
                            { value: 'all', label: messages.all },
                            { value: 'vkl', label: 'VKL' },
                            { value: 'mbks', label: 'MBKS' },
                            { value: 'otr', label: 'OTR' },
                          ]}
                        />
                      ) : null}

                      <FormTags
                        label={messages.emails}
                        name="emails"
                        value={entity.getEmails()}
                        meta={entity.getEmailsMetaInformation()}
                        validation={entity.getEmailsValidationResult()}
                        onChange={this.updateEntity}
                        messages={messages}
                        disabled={disabled}
                      />

                      {/* if the LeadImporter plugin is active, the user may activate the XML content */}
                      {/* in this case, the email will content only the XML data (not human readable!) */}
                      {dataEmailCoPluginActive && (
                        <div class="form-group form-group-default">
                          <FormSwitchery
                            name="includeCustomerOneXmlData"
                            label={messages.include_xml_data_in_email}
                            value
                            checked={entity.getIncludeCustomerOneXmlData()}
                            onChange={this.updateEntity}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}
LeadPerMailRuleData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
  };
};

export default injectIntl(connect(mapStateToProps)(LeadPerMailRuleData));
